const filtrosOpcoes = (state) => {
  return state.filtros_opcoes || {}
}

const filtros = (state) => {
  return state.filtros || {}
}

const profissionaisAtivos = (state) => {
  // lista de opção de filtros que validam quais profissionais vão ser mostrados
  // key: referente a chave presente no objeto do profissional, então se precisar de uma nova validação so adicionar a chave
  // validation: recebe o método de validação
  const filterProfessional = [
    {
      key: 'auc',
      validation: (v) =>
        state.optionFilter.auc ? v > state.optionFilter.auc : true,
    },
    { key: 'ativo', validation: (v) => (state.optionFilter.active ? v : true) },
  ]

  if (!state.profissionais.data) {
    return []
  }

  return state.profissionais.data.filter((professional) => {
    return filterProfessional.every((filter) => {
      return filter.validation(professional[filter.key])
    })
  })
}

const sortedProfessionalsActives = (state) => {
  const data = [...state.profissionais.data]

  return data.sort((a, b) => {
    return a.ativo === b.ativo ? 0 : a.ativo ? -1 : 1
  })
}

const profissionais = (state) => {
  return state.profissionais.data || []
}

const profissionaisMetadata = (state) => {
  return state.profissionais.metadata || {}
}

const profissionaisDataAtualizacao = (state) => {
  return state.profissionais.lastUpdate
}

const loadingProfissionais = (state) => {
  return state.profissionais.loading
}

const segmentos = (state) => {
  return state.segmentos.data || []
}

const segmentosCores = (state) => {
  return state.segmentos.cores || {}
}

const segmentosDataAtualizacao = (state) => {
  return state.segmentos.lastUpdate
}

const segmentosLoading = (state) => {
  return state.segmentos.loading
}

const corteQuadrantes = (state) => {
  return state.faixaCorteQuadrantes.data || {}
}

const quadrantesLoading = (state) => {
  return state.faixaCorteQuadrantes.loading
}

const quadrantesDataAtualizacao = (state) => {
  return state.faixaCorteQuadrantes.lastUpdate
}

const qtdProfissionaisPoolSocietario = (state) => {
  return state.qtdProfissionaisPoolSocietario
}

const empresas = (state) => {
  return state.empresas.data
}

const empresasSortedActive = (state) => {
  return [...(state.empresas.data || [])].sort((a, b) => {
    return a.ativo === b.ativo ? 0 : a.ativo ? -1 : 1
  })
}

const empresasLoading = (state) => {
  return state.empresas.loading
}

const empresasDataAtualizacao = (state) => {
  return state.empresas.lastUpdate
}

const hierarquiaEmpresas = (state) => {
  return state.hierarquiaEmpresas.data || {}
}

const hierarquiaEmpresasLoading = (state) => {
  return state.hierarquiaEmpresas.loading
}

const hierarquiaEmpresasDataAtualizacao = (state) => {
  return state.hierarquiaEmpresas.lastUpdate
}

const temDadosFinanceiro = (state) => {
  return state.temDadosFinanceiro.data
}

const planosCarreira = (state) => {
  return state.planosCarreira.data
}

const planosCarreiraSortedActive = (state) => {
  return [...(state.planosCarreira.data || [])].sort((a, b) => {
    return a.ativo === b.ativo ? 0 : a.ativo ? -1 : 1
  })
}

const planosCarreiraLoading = (state) => {
  return state.planosCarreira.loading
}

const planosCarreiraDataAtualizacao = (state) => {
  return state.planosCarreira.lastUpdate
}

const planoSelecionado = (state) => {
  return state.planoSelecionado.data.plano || {}
}

const planoSelecionadoDados = (state) => {
  return state.planoSelecionado.data.dados_planos || []
}

const planoSelecionadoLoading = (state) => {
  return state.planoSelecionado.loading
}

const senioridade = (state) => {
  return state.senioridade.data || []
}

const senioridadeLoading = (state) => {
  return state.senioridade.loading
}

const senioridadeDataAtualizacao = (state) => {
  return state.senioridade.lastUpdate
}

const dadosGerais = (state) => {
  return state.dadosGerais.data || {}
}

const dadosGeraisLoading = (state) => {
  return state.dadosGerais.loading
}

const dadosGeraisDataAtualizacao = (state) => {
  return state.dadosGerais.lastUpdate
}

const documentos = (state) => (id_profissional) => {
  if (id_profissional <= 0 || !state.documentos.data[id_profissional]) {
    return []
  }
  return state.documentos.data[id_profissional].data || []
}

const documentosLoading = (state) => (id_profissional) => {
  if (id_profissional <= 0 || !state.documentos.data[id_profissional]) {
    return false
  }
  return state.documentos.data[id_profissional].loading
}

const documentosDataAtualizacao = (state) => (id_profissional) => {
  if (id_profissional <= 0 || !state.documentos.data[id_profissional]) {
    return null
  }
  return state.documentos.data[id_profissional].lastUpdate
}

const financeiroUnico = (state) => {
  return state.financeiroUnico.data || {}
}

const financeiroUnicoZerado = (state) => {
  return state.financeiroUnico.hasZeroValue
}

const financeiroUnicoLoading = (state) => {
  return state.financeiroUnico.loading
}

const financeiroUnicoDataAtualizacao = (state) => {
  return state.financeiroUnico.lastUpdate
}

const financeiroConversao = (state) => {
  return state.financeiroConversao.data || {}
}

const financeiroConversaoZerado = (state) => {
  return state.financeiroConversao.hasZeroValue
}

const financeiroConversaoLoading = (state) => {
  return state.financeiroConversao.loading
}

const financeiroConversaoDataAtualizacao = (state) => {
  return state.financeiroConversao.lastUpdate
}

const financeiroComissao = (state) => {
  return state.financeiroComissao.data || {}
}

const financeiroComissaoZerado = (state) => {
  return state.financeiroComissao.hasZeroValue
}

const financeiroComissaoLoading = (state) => {
  return state.financeiroComissao.loading
}

const financeiroComissaoDataAtualizacao = (state) => {
  return state.financeiroComissao.lastUpdate
}

const tiposProfissionais = (state) => {
  return state.tiposProfissionais.data || []
}

const parametrosRegioes = (state) => {
  return state.parametrosRegioes.data || []
}

const parametrosRegioesOpcoes = (state) => {
  return state.parametrosRegioes.opcoes || []
}

const parametrosRegioesLoading = (state) => {
  return state.parametrosRegioes.loading
}

const parametrosRegioesDataAtualizacao = (state) => {
  return state.parametrosRegioes.lastUpdate
}

const parametrosSegmentos = (state) => {
  return state.parametrosSegmentos.data || {}
}

const parametrosSegmentosLoading = (state) => {
  return state.parametrosSegmentos.loading
}

const parametrosSegmentosDataAtualizacao = (state) => {
  return state.parametrosSegmentos.lastUpdate
}

const parametrosContratacoes = (state) => {
  return state.parametrosContratacoes.data || {}
}

const parametrosContratacoesLoading = (state) => {
  return state.parametrosContratacoes.loading
}

const parametrosContratacoesDataAtualizacao = (state) => {
  return state.parametrosContratacoes.lastUpdate
}

const parametrosIncentivos = (state) => {
  return state.parametrosIncentivos.data || {}
}

const parametrosIncentivosLoading = (state) => {
  return state.parametrosIncentivos.loading
}

const parametrosIncentivosDataAtualizacao = (state) => {
  return state.parametrosIncentivos.lastUpdate
}

const parametrosMetasEscritorio = (state) => {
  return state.parametrosMetasEscritorio.data || {}
}

const parametrosMetasEscritorioLoading = (state) => {
  return state.parametrosMetasEscritorio.loading
}

const parametrosMetasEscritorioDataAtualizacao = (state) => {
  return state.parametrosMetasEscritorio.lastUpdate
}

const parametrosMetasProfissionais = (state) => {
  return state.parametrosMetasProfissionais.data || {}
}

const parametrosMetasProfissionaisLista = (state) => {
  return state.parametrosMetasProfissionais.lista || []
}

const parametrosMetasProfissionaisLoading = (state) => {
  return state.parametrosMetasProfissionais.loading
}

const parametrosMetasProfissionaisDataAtualizacao = (state) => {
  return state.parametrosMetasProfissionais.lastUpdate
}

const projecaoAuC = (state) => {
  return (
    state.projecaoAuC.data || {
      auc: {},
      current_dre: {},
      hiring_plan: {},
      projected_dre: {},
      valuation: {},
    }
  )
}

const projecaoAuCStatus = (state) => {
  return {
    status: state.projecaoAuC.status,
    message: state.projecaoAuC.message,
  }
}

const projecaoAuCLoading = (state) => {
  return state.projecaoAuC.loading
}

const projecaoAuCDataAtualizacao = (state) => {
  return state.projecaoAuC.lastUpdate
}

const historicoAuC = (state) => {
  return (
    state.historicoAuC.data || {
      office: {
        captacao_3m: {},
        captacao_inicio: {},
      },
      professional: {
        captacao_3m: {},
        captacao_inicio: {},
      },
    }
  )
}

const historicoAuCOffice = (state) => {
  return state.historicoAuC.data.office
}

const historicoAuCProfessional = (state) => {
  return state.historicoAuC.data.professional
}

const historicoAuCPorProfissional = (state) => (id_profissional) => {
  return state.historicoAuCProfissional.data[id_profissional] || {}
}

const historicoAuCPorProfissionalLoading = (state) => {
  return state.historicoAuCProfissional.loading
}

const historicoAuCPorProfissionalDataAtualizacao = (state) => {
  return state.historicoAuCProfissional.lastUpdate
}

const historicoAuCLoading = (state) => {
  return state.historicoAuC.loading
}

const historicoAuCDataAtualizacao = (state) => {
  return state.historicoAuC.lastUpdate
}

const contratacoesEfetivadas = (state) => {
  return state.contratacoesEfetivadas.data || []
}

const contratacoesEfetivadasSum = (state) => {
  return state.contratacoesEfetivadas.sum || {}
}

const contratacoesEfetivadasClusters = (state) => {
  return state.contratacoesEfetivadas.clusters || {}
}

const contratacoesEfetivadasLoading = (state) => {
  return state.contratacoesEfetivadas.loading
}

const contratacoesEfetivadasDataAtualizacao = (state) => {
  return state.contratacoesEfetivadas.lastUpdate
}

const parametrosAdicionais = (state) => {
  return state.parametrosAdicionais.data || {}
}

const parametrosAdicionaisLoading = (state) => {
  return state.parametrosAdicionais.loading
}

const parametrosAdicionaisDataAtualizacao = (state) => {
  return state.parametrosAdicionais.lastUpdate
}

const custosAdicionais = (state) => {
  return state.custosAdicionais.data || []
}

const custosAdicionaisLoading = (state) => {
  return state.custosAdicionais.loading
}

const custosAdicionaisDataAtualizacao = (state) => {
  return state.custosAdicionais.lastUpdate
}

const historicoPlanilhas = (state) => {
  return state.historicoPlanilhas.data || []
}

const historicoPlanilhasPorTipo = (state) => {
  return state.historicoPlanilhas.dicLastByType || {}
}

const historicoPlanilhasLoading = (state) => {
  return state.historicoPlanilhas.loading
}

const historicoPlanilhasDataAtualizacao = (state) => {
  return state.historicoPlanilhas.lastUpdate
}

export const multiplos = (state) => {
  return state.multiplos.data || ['EBITDA', 'Lucro Líquido', 'Receita Bruta']
}

export const multiplosLoading = (state) => {
  return state.multiplos.loading
}

export const multiplosLastUpdate = (state) => {
  return state.multiplos.lastUpdate
}

const externAgents = (state) => {
  return state.externAgents.data || []
}

const externAgentsLoading = (state) => {
  return state.externAgents.loading
}

const externAgentsLastUpdate = (state) => {
  return state.externAgents.lastUpdate
}

const partnershipsProfessionals = (state) => {
  return state.partnershipsProfessionals.data || []
}

const partnershipsProfessionalsLoading = (state) => {
  return state.partnershipsProfessionals.loading
}

const partnershipsProfessionalsLastUpdate = (state) => {
  return state.partnershipsProfessionals.lastUpdate
}

const partnershipsExternAgents = (state) => {
  return state.partnershipsExternAgents.data || []
}

const partnershipsExternAgentsLoading = (state) => {
  return state.partnershipsExternAgents.loading
}

const partnershipsExternAgentsLastUpdate = (state) => {
  return state.partnershipsExternAgents.lastUpdate
}

export const filiais = (state) => {
  return state.filiais.data || []
}

export const filiaisSortedActive = (state) => {
  const data = [...state.filiais.data]
  return (
    [...(state.filiais.data || [])].sort((a, b) => {
      return a.ativo === b.ativo ? 0 : a.ativo ? -1 : 1
    }) || []
  )
}

export const filiaisLoading = (state) => {
  return state.filiais.loading
}

export const filiaisLastUpdate = (state) => {
  return state.filiais.lastUpdate
}

export const projecaoAucTeam = (state) => {
  return state.projecaoAucTeam.data || {}
}

export const projecaoAucTeamLoading = (state) => {
  return state.projecaoAucTeam.loading
}

export const projecaoAucTeamLastUpdate = (state) => {
  return state.projecaoAucTeam.lastUpdate
}

export const dataRoomFiles = (state) => {
  return state.dataRoomFiles.data || []
}
export const dataRoomFilesLoading = (state) => {
  return state.dataRoomFiles.loading
}
export const dataRoomLastUpdate = (state) => {
  return state.dataRoomFiles.lastUpdate
}
export const dataRoomOptions = (state) => {
  return state.dataRoomOptions.data || []
}
export const dataRoomOptionsLoading = (state) => {
  return state.dataRoomOptions.loading
}

export const optionsRequiredFiles = (state) => {
  return state.optionsRequiredFiles.data || []
}

export const dataRoomSelectedYear = (state) => {
  return state.dataRoomSelectedYear
}

export {
  filtrosOpcoes,
  filtros,
  profissionais,
  profissionaisAtivos,
  profissionaisMetadata,
  loadingProfissionais,
  profissionaisDataAtualizacao,
  segmentos,
  segmentosCores,
  segmentosDataAtualizacao,
  segmentosLoading,
  corteQuadrantes,
  quadrantesLoading,
  quadrantesDataAtualizacao,
  qtdProfissionaisPoolSocietario,
  empresas,
  empresasLoading,
  empresasSortedActive,
  empresasDataAtualizacao,
  hierarquiaEmpresas,
  hierarquiaEmpresasLoading,
  temDadosFinanceiro,
  hierarquiaEmpresasDataAtualizacao,
  planosCarreira,
  planosCarreiraSortedActive,
  planosCarreiraLoading,
  planosCarreiraDataAtualizacao,
  planoSelecionado,
  planoSelecionadoDados,
  planoSelecionadoLoading,
  senioridade,
  senioridadeLoading,
  senioridadeDataAtualizacao,
  dadosGerais,
  dadosGeraisLoading,
  dadosGeraisDataAtualizacao,
  documentos,
  documentosLoading,
  documentosDataAtualizacao,
  financeiroUnicoZerado,
  financeiroConversaoZerado,
  financeiroComissaoZerado,
  financeiroUnico,
  financeiroUnicoLoading,
  financeiroUnicoDataAtualizacao,
  financeiroConversao,
  financeiroConversaoLoading,
  financeiroConversaoDataAtualizacao,
  financeiroComissao,
  financeiroComissaoLoading,
  financeiroComissaoDataAtualizacao,
  tiposProfissionais,
  parametrosRegioes,
  parametrosRegioesOpcoes,
  parametrosRegioesLoading,
  parametrosRegioesDataAtualizacao,
  parametrosSegmentos,
  parametrosSegmentosLoading,
  parametrosSegmentosDataAtualizacao,
  parametrosContratacoes,
  parametrosContratacoesLoading,
  parametrosContratacoesDataAtualizacao,
  parametrosIncentivos,
  parametrosIncentivosLoading,
  parametrosIncentivosDataAtualizacao,
  parametrosMetasEscritorio,
  parametrosMetasEscritorioLoading,
  parametrosMetasEscritorioDataAtualizacao,
  parametrosMetasProfissionais,
  parametrosMetasProfissionaisLista,
  parametrosMetasProfissionaisLoading,
  parametrosMetasProfissionaisDataAtualizacao,
  projecaoAuC,
  projecaoAuCStatus,
  projecaoAuCLoading,
  projecaoAuCDataAtualizacao,
  historicoAuC,
  historicoAuCLoading,
  historicoAuCDataAtualizacao,
  historicoAuCPorProfissional,
  historicoAuCPorProfissionalLoading,
  historicoAuCPorProfissionalDataAtualizacao,
  historicoAuCOffice,
  historicoAuCProfessional,
  contratacoesEfetivadas,
  contratacoesEfetivadasSum,
  contratacoesEfetivadasClusters,
  contratacoesEfetivadasLoading,
  contratacoesEfetivadasDataAtualizacao,
  parametrosAdicionais,
  parametrosAdicionaisLoading,
  parametrosAdicionaisDataAtualizacao,
  custosAdicionais,
  custosAdicionaisLoading,
  custosAdicionaisDataAtualizacao,
  historicoPlanilhas,
  historicoPlanilhasPorTipo,
  historicoPlanilhasLoading,
  historicoPlanilhasDataAtualizacao,
  externAgents,
  externAgentsLoading,
  externAgentsLastUpdate,
  partnershipsProfessionals,
  partnershipsProfessionalsLoading,
  partnershipsProfessionalsLastUpdate,
  partnershipsExternAgents,
  partnershipsExternAgentsLoading,
  partnershipsExternAgentsLastUpdate,
  sortedProfessionalsActives,
}
